import { campaign } from '@/json/json_loader';
import { ActionBase } from '@/models/action_base';
import RouterConst from '@/router/router_const';
import { KbnConst } from '@/utils/kbn';

import { useActionCommonUpdate } from './use_action_common_update';
import { generateActionExternalRedirect } from './use_action_external_redirect';
import { useActionOpenExternalXShare } from './use_action_open_external_x_share';
import { useActionQueryTransition } from './use_action_query_transition';
import { useActionRedirectIfNotAnswered } from './use_action_redirect_if_answered_survey';
import { useRouting } from './use_routing';

/**
 * カスタマイズアクション
 */
export class ActionCustomizing extends ActionBase {
  typeKbn = KbnConst.ACTION_TYPE_KBN_CUSTOMIZING;

  keyName?: string;

  use() {
    const externalRedirect = generateActionExternalRedirect().use();
    const routing = useRouting();
    const actionRedirectIfNotAnsweredTieUp = useActionRedirectIfNotAnswered(routing, RouterConst.TieUpSurvey);
    const actionRedirectIfNotAnsweredNational = useActionRedirectIfNotAnswered(routing, RouterConst.NationalSurvey);
    const actionCommonUpdate = useActionCommonUpdate();
    const actionQueryTransition = useActionQueryTransition();
    const actionOpenExternalXShare = useActionOpenExternalXShare();
    return async () => await execute(this.keyName, externalRedirect, actionRedirectIfNotAnsweredTieUp, actionRedirectIfNotAnsweredNational, actionCommonUpdate, actionQueryTransition, actionOpenExternalXShare);
  }

  constructor(init: Partial<ActionCustomizing> = {}) {
    super();
    Object.assign(this, init);
  }
}

async function execute(
  keyName: string | undefined,
  externalRedirect: (url?: string) => Promise<boolean>,
  actionRedirectIfNotAnsweredTieUp: () => Promise<boolean>,
  actionRedirectIfNotAnsweredNational: () => Promise<boolean>,
  actionCommonUpdate: () => Promise<boolean>,
  actionQueryTransition: () => Promise<boolean>,
  openExternalXShare: () => Promise<boolean>,
) {

  if (keyName === 'redirect_lp') {
    return await externalRedirect(campaign.escapeUrl); //escapeUrlに指定した先がLPおよびキャンペーンページと同一
  }
  if (keyName === 'redirect_if_not_answered_tie_up') {
    return await actionRedirectIfNotAnsweredTieUp();
  }
  if (keyName === 'redirect_if_not_answered_national') {
    return await actionRedirectIfNotAnsweredNational();
  }
  if (keyName === 'common_update') {
    return await actionCommonUpdate();
  }
  if (keyName === 'query_transition') {
    return await actionQueryTransition();
  }
  if (keyName === 'x_share') {
    return await openExternalXShare();
  }

  // キー名を使って好きな処理を実行できる
  alert(`このアクションは未実装（キー名: ${ keyName }）`);
  return false;
}

export function generateActionCustomizing(keyName?: string): ActionCustomizing {
  return new ActionCustomizing({
    keyName,
  });
}
